import { render, staticRenderFns } from "./RateSummaryBiz.vue?vue&type=template&id=6dd836aa&scoped=true"
import script from "./RateSummaryBiz.vue?vue&type=script&lang=js"
export * from "./RateSummaryBiz.vue?vue&type=script&lang=js"
import style0 from "./RateSummaryBiz.vue?vue&type=style&index=0&id=6dd836aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd836aa",
  null
  
)

export default component.exports